/**
 * The article masthead's full-bleed box, as `RevampHeroImage` draws it: the
 * directory masthead's tall crop on the phone, the design's 1200x868 past md.
 *
 * Shared with the Business Manager page builder, which stands its banner
 * control in this box so the author crops to the frame the reader gets. Stated
 * once rather than copied: the phone crop has already been retuned once, and a
 * copy would have gone stale without anything failing.
 *
 * Deliberately a leaf — no imports at all. `banner-utils` reads the ratios, and
 * `themes/archipro2` compiles that file through its own `~/utils/*` path
 * mapping without defining `@modules/*` or the generated GraphQL types. Anything
 * this file imported would have to resolve in that project too.
 */

/** The box the hero is drawn in, full bleed. */
export const REVAMP_HERO_BLEED_BOX =
    'max-md:aspect-[414/560] max-md:max-h-[80svh] md:aspect-[1200/868] md:max-h-[86.8125rem]';

/** The same box as numbers, for the banner dimensions and the crop frame. */
export const REVAMP_HERO_DESKTOP_RATIO = 1200 / 868;
export const REVAMP_HERO_MOBILE_RATIO = 414 / 560;
